/** Client-safe Ask Engage handshake. No Customer Help catalog imports. */

export const PORTAL_ASK_ENGAGE_EVENT = 's2r:portal-ask-engage'

export const PORTAL_ASK_ENGAGE_LABEL = 'Ask Engage'

/** Body flag set only by the signed-in portal operator widget. */
export const PORTAL_OPERATOR_HELP_FLAG = 'portal_operator_help'

export const PORTAL_OPERATOR_HELP_SLUG_FIELD = 'customer_help_slug'

export const PORTAL_OPERATOR_HELP_CONTROL_FIELD = 'customer_help_control'

export type PortalAskEngageDetail = {
  slug: string
  title: string
  control?: string
}

/** Public widget and customer-site embeds omit cookies. Portal operator chat includes them. */
export function engageWidgetChatCredentials(portalSession: boolean): RequestCredentials {
  return portalSession ? 'include' : 'omit'
}

export function formatPortalAskEngageMessage(detail: Pick<PortalAskEngageDetail, 'title' | 'control'>): string {
  const control = detail.control ? ` The control is ${detail.control}.` : ''
  return `How do I use ${detail.title} on this screen?${control} Answer from Customer Help.`
}

export function readPortalAskEngageDetail(event: Event): PortalAskEngageDetail | null {
  if (!(event instanceof CustomEvent)) return null
  const detail: unknown = event.detail
  if (!detail || typeof detail !== 'object') return null
  const record = detail as Record<string, unknown>
  const slug = typeof record.slug === 'string' ? record.slug.trim() : ''
  const title = typeof record.title === 'string' ? record.title.trim() : ''
  const control = typeof record.control === 'string' ? record.control.trim() : ''
  if (!slug || !title) return null
  return control ? { slug, title, control } : { slug, title }
}
